module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "main-view"
    }
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('router-view', {
    attrs: {
      "name": "header"
    }
  }), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "footer"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a1cb3fc4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 674
// module chunks = 5